import React from 'react'
import CareerSection from '../../component/Careers/CareerHeader/CareerSection'
import CareerForm from '../../component/Careers/CareerForm/CareerForm'
import BenefitsSection from '../../component/Careers/BenefitsSection/BenefitsSection'
import CareerHeader from '../../component/Careers/CareerHeader/CareerHeader'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import FloatingContactUs from '../../component/floting_contact/FloatingContactUs'
import { Helmet } from "react-helmet-async";



const CareerPage = () => {
  return (
   <> 
        {/* ✅ Meta Tags for SEO */}
      
      <Helmet>
        <title>Careers at Nextech PLM | Join Our PLM Expert Team in Pune</title>
        <meta name="description" content="Join Nextech PLM in Pune, India. Explore exciting career opportunities and be part of a leading PLM consulting and services company." />
        <meta name="keywords" content="PLM careers Pune, Teamcenter jobs India, NexTech PLM careers, PLM consultant jobs, engineering jobs Pune, Siemens Teamcenter careers" />
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
        <link rel="canonical" href="https://nextechplm.com/career" />
        <meta property="og:site_name" content="NexTech PLM Solutions" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Careers at Nextech PLM | Join Our PLM Expert Team in Pune" />
        <meta property="og:description" content="Join Nextech PLM in Pune, India. Explore exciting career opportunities and be part of a leading PLM consulting and services company." />
        <meta property="og:url" content="https://nextechplm.com/career" />
        <meta property="og:image" content="https://nextechplm.com/logo192.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Careers at Nextech PLM | Join Our PLM Expert Team in Pune" />
        <meta name="twitter:description" content="Join Nextech PLM in Pune, India. Explore exciting career opportunities and be part of a leading PLM consulting and services company." />
        <meta name="twitter:image" content="https://nextechplm.com/logo192.png" />
      </Helmet>

        <ToastContainer />
        <FloatingContactUs />
        <CareerHeader />
        <CareerSection />
        <BenefitsSection />
        <CareerForm />
    </>
  )
}

export default CareerPage;